import { render } from "./FormItem.vue?vue&type=template&id=3f91f96c"
import script from "./FormItem.vue?vue&type=script&lang=ts"
export * from "./FormItem.vue?vue&type=script&lang=ts"

import "./FormItem.vue?vue&type=style&index=0&id=3f91f96c&lang=scss"
script.render = render

export default script